<template>
    <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4 px-5">

        <template v-if="isAccepted === null">
            <a class="mt-5 block relative faded border p-4 rounded-lg rounded-b-none text-center cursor-pointer space-y-2"
               :class="{
                    'bg-white border-gray-300': ! isAccepted,
                    [`bg-${$root.theme}-50 border-${$root.theme}-700`]: isAccepted
                }">
                <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug px-5`">
                    Reduce the amount of your first payment by setting it up today!
                </p>
                <p class="text-sm text-gray-400 leading-snug px-5">
                    only applicable to payment arrangements with multiple payments
                </p>
            </a>
            <div class="border overflow-hidden border-t-0 rounded-b-lg text-center font-medium flex"
                 :class="{
                        'bg-white border-gray-300': ! isAccepted,
                        [`bg-${$root.theme}-50 border-${$root.theme}-700`]: isAccepted
                    }">
                <a @click.prevent="$emit('accepted')" href="#"
                   :class="`bg-${$root.theme}-50 hover:bg-${$root.theme}-100 shadow-inner flex-1 py-3 border-r text-${$root.theme}-700`">
                    Click to Accept
                </a>
                <a @click.prevent="$emit('declined')" href="#"
                   class="bg-gray-50 hover:bg-gray-100 shadow-inner flex-1 py-3 text-gray-400">
                    Decline
                </a>
            </div>
        </template>
        <template v-else-if="isAccepted">
            <div class="mt-5 block relative faded border p-4 rounded-lg text-center space-y-2"
                 :class="{
                        'bg-white border-gray-300': ! isAccepted,
                        [`bg-${$root.theme}-50 border-${$root.theme}-700`]: isAccepted
                    }">
                <p :class="`font-sm font-medium text-${$root.theme}-700`">
                    Select your payment plan to take advantage of your first payment reduction!
                </p>
            </div>
        </template>
        <template v-else-if="extraIsAccepted">
            <div class="mt-5 block relative faded border p-4 rounded-lg text-center space-y-2"
                 :class="{
                        'bg-white border-gray-300': ! extraIsAccepted,
                        [`bg-${$root.theme}-50 border-${$root.theme}-700`]: extraIsAccepted
                    }">
                <p :class="`font-sm font-medium text-${$root.theme}-700`">
                    Select your payment plan to take advantage of your extra payment!
                </p>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['is-accepted', 'extra-is-accepted']
    }
</script>
